<template>

  <div>
    <div class="mb-3">
      <textarea-mention
        v-model="value.note"
        :placeholder="$t('Note. Use @ to mention someone.')">
        </textarea-mention>

      <ValidateMessage :error="validateErrors.note" />
    </div>
    <div :class="{'box-loading': loading}">
      <button
        type="submit"
        class="btn btn-primary"
        @click="saveNote(value)">
        {{ $t('Save') }}
        </button>
      <button
        v-if="value._id"
        type="submit" class="btn btn-light"
        @click="$emit('cancel')">
        {{ $t('Cancel') }}
        </button>
    </div>
  </div>

</template>

<script>
import TextareaMention from '@/components/Fields/TextareaMention'
import Formsave from '@/utils/Formsave'

export default {
  name: 'CandidateNoteForm',
  components: {
    TextareaMention
  },
  props: [
    'initValue'
  ],
  data () {
    return {
      validateErrors: false,
      loading: false,
      value: this.defaultValues(this.initValue)
    }
  },
  computed: {
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    }
  },
  created () {
    if (!this.value._id) {
      Formsave.sync(this, 'CandidateNote', this.candidate._id, 'value', (data) => {
        return data.note
      })
    }
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    saveNote
    */
    saveNote (data) {
      if (data._id) this.updateNote(data)
      else this.createNote(data)
    },
    /*
    resetNote
    */
    resetNote () {
      this.value.note = ''
      this.validateErrors = false
    },
    /*
    createNote
    */
    createNote (data) {
      this.loading = true

      data.candidate_id = this.candidate._id
      data.job_id = this.selectedJob._id

      this.$store
      .dispatch('createNote', data)
      .then((result) => {
        this.loading = false
        this.resetNote()
        this.$emit('created', result.data)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateNote
    */
    updateNote (data) {
      this.loading = true

      this.$store
      .dispatch('updateNote', data)
      .then((result) => {
        this.loading = false
        this.$emit('updated', data)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Note/CandidateNoteForm.vue